var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFboReportSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.86706 1H3.64573C2.95985 1 2.40577 1.70069 2.40577 2.55586L2.40039 13.4441C2.40039 14.2993 2.95447 15 3.63766 15H12.355C13.0382 15 13.6004 14.2993 13.6004 13.4441V5.66759L9.86706 1ZM3.64573 13.4441V2.55586H9.24573V5.34207C9.24573 5.95172 9.68954 6.44552 10.2382 6.44552H12.355V13.4469H3.64573V13.4441ZM6.13641 9.2731H9.86706C10.2087 9.2731 10.4884 8.98897 10.4884 8.63586C10.4884 8.28552 10.2113 7.99862 9.86706 7.99862H6.13372C5.79213 7.99862 5.5124 8.28276 5.5124 8.63586C5.5124 8.98621 5.78944 9.2731 6.13372 9.2731H6.13641ZM6.13641 11.8H9.86706C10.2087 11.8 10.4884 11.5159 10.4884 11.1628C10.4884 10.8124 10.2113 10.5255 9.86706 10.5255H6.13372C5.79213 10.5255 5.5124 10.8097 5.5124 11.1628C5.5124 11.5131 5.78944 11.8 6.13372 11.8H6.13641Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFboReportSmall);
export default __webpack_public_path__ + "static/media/FBOReportSmall.6b56c500241d5a8c78604393f9dc0b0e.svg";
export { ForwardRef as ReactComponent };